module.exports = __webpack_public_path__ + "img/menu_2.ddeabee7.png";